import { render } from "./DcConfirmationDialog.vue?vue&type=template&id=350ef074&scoped=true"
import script from "./DcConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DcConfirmationDialog.vue?vue&type=script&lang=js"

import "./DcConfirmationDialog.vue?vue&type=style&index=0&id=350ef074&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350ef074"]])

export default __exports__